// Org IDs in Auth0
export const GRANDSKY_ORG_ID = "org_C14ErQWYGe0OjJde";
export const AEROX_ORG_ID = "org_fBQ1YDarZdeCSV6a";